import {Component, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {TranslocoService} from "@ngneat/transloco";
import {Lookups, RaceAdditionalPricingItem} from "@model";
import {CurrencyPipe} from "@pipes";

@Component({
  selector: 'app-register-to-race-additional-item-output',
  templateUrl: './register-to-race-additional-item-output.component.html',
  styleUrls: ['./register-to-race-additional-item-output.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class RegisterToRaceAdditionalItemOutput {
  @Input() eventCurrencyLabel: string | undefined;
  @Input() defaultLanguage?: number;
  @Input() raceAdditionalPricingItem: RaceAdditionalPricingItem | undefined;
  @Input({required:true}) languages: Lookups[] = [];

  constructor(private translocoService: TranslocoService, private currencyPipe: CurrencyPipe) {
  }

  getPriceLabel(): string {
    let label: string = "";
    let price: string = "";
    if (this.raceAdditionalPricingItem?.priceConstant === true) {
      price = this.currencyPipe.transform(this.raceAdditionalPricingItem?.price) + " " + this.eventCurrencyLabel;
    } else if (this.raceAdditionalPricingItem!.pricingItemValues?.length === 1 && !!this.raceAdditionalPricingItem!.pricingItemValues[0].price) {
      price = this.currencyPipe.transform(this.raceAdditionalPricingItem!.pricingItemValues[0].price) + " " + this.eventCurrencyLabel;
    }
    return label + " " + price;
  }
}
